export const action = {
  PROVIDER_VALIDATION_LOADING: 'PROVIDER_VALIDATION_LOADING',
  PROVIDER_VALIDATION_SUCCESS: 'PROVIDER_VALIDATION_SUCCESS',
  PROVIDER_VALIDATION_ERROR: 'PROVIDER_VALIDATION_ERROR',
};
